import http from '../../../utils/http'

export const getCallList = (params = {}) => {
  return http({
    url: '/call/list',
    params
  })
}

export const saveCall = data => {
  return http({
    url: '/call/saveCall',
    method: 'post',
    data
  })
}

export const updateCall = data => {
  return http({
    url: '/call/updateCall',
    method: 'post',
    data
  })
}

export const removeCall = (params = {}) => {
  return http({
    url: '/call/deleteCall',
    params
  })
}
